import React, { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { GrFormClose } from "react-icons/gr";
import { FaEdit } from "react-icons/fa";
import Select from "react-select";
import moment from "moment";
import { Button } from "antd";
import { createPIS } from "../api/CRUD/CreatePIS";
import { GenerateAccessToken } from "../api/generateAccessToken";
import { Logout } from "../api/login/logout";
import { logout, setAccessToken } from "../redux/slice/UserSlice";
import { useAppDispatch, useAppSelector } from "../redux/hooks";

export const PISCreate: React.FC<{
  setToggleModal: React.Dispatch<React.SetStateAction<boolean>>;
  callgetPIS: any;
}> = ({ setToggleModal = () => {}, callgetPIS }) => {
  
  const User = useAppSelector((state: any) => state.User);
  const dispatch = useAppDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [Name, setName] = useState<string | undefined>();
  const [DestinationDirection, setDestinationDirection] = useState<string>();
  const [Lat, setLat] = useState<string>();
  const [Long, setLong] = useState<string>();
  const [DisLat, setDisLat] = useState<string>();
  const [DisLong, setDisLong] = useState<string>();
  const [DeviceId1, setDeviceId1] = useState<string | undefined>();
  const [DeviceId2, setDeviceId2] = useState<string | undefined>();
  const [Remarks, setRemarks] = useState<string | undefined>();
  const regenerateToken = async () => {
    const res = await GenerateAccessToken(User.refreshToken).catch((e) => {
      Logout(User.refreshToken);
      dispatch(logout());
    });
    if (!!res?.token) {
      dispatch(
        setAccessToken({
          token: res?.token,
        })
      );
    }
  };
  const callCreatePIS = async () => {
    if (
      !!Name &&
      !!DestinationDirection &&
      !!Lat &&
      !!Long &&
      !!DisLat &&
      !!DisLong &&
      !!DeviceId1 &&
      !!DeviceId2 &&
      !!Remarks
    ) {
      const result = await createPIS(
        Name,
        DestinationDirection,
        Lat,
        Long,
        DisLat,
        DisLong,
        DeviceId1,
        DeviceId2,
        Remarks,
        User?.token
      ).catch((err) => {
        if (err.response.status === 401) {
          regenerateToken();
          callCreatePIS();
        }
      });
      if (result.status === 200) {
        enqueueSnackbar("Data Inserted Successfully", {
          variant: "success",
        });
        callgetPIS();
        setToggleModal(false);
      } else {
        enqueueSnackbar("Data Insertion Failed", {
          variant: "error",
        });
      }
    } else {
      window.alert("Please fill all the fields.");
    }
  };
  return (
    <div className="bg-white w-4/6 absolute">
      <div className="flex flex-row justify-between px-2 pt-2 pb-1 bg-slate-300 border-b-2">
        <p className="font-semibold flex flex-row m-0">
          <span className="pt-1 pr-2">
            <FaEdit />
          </span>{" "}
          Create
        </p>
        <GrFormClose
          size={25}
          className="cursor-pointer"
          onClick={() => setToggleModal(false)}
        />
      </div>
      <div className="mx-5 mt-5 mb-10">
        <div className="flex flex-col justify-center ">
          <div className="flex flex-row justify-between gap-x-10 pb-4">
            <div className="flex flex-col flex-1">
              <label className="text-sm pb-2 font-semibold text-gray-500">
                <span className=" text-blue-600">*</span>Bus Stop Name
              </label>
              <input
                type="text"
                className="border-2 border-gray-700 px-3 py-2"
                value={Name}
                placeholder="Ex: Coal India"
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="flex flex-col flex-1">
              <label className="text-sm pb-2 font-semibold text-gray-500">
                <span className=" text-blue-600">*</span>Destination Direction
              </label>
              <input
                type="text"
                className="border-2 border-gray-700 px-3 py-2"
                value={DestinationDirection}
                placeholder="Ex: [1,4]"
                onChange={(e) => setDestinationDirection(e.target.value)}
              />
            </div>
          </div>
          <div className="flex flex-row justify-between gap-x-10 pb-4">
            <div className="flex flex-col flex-1">
              <label className="text-sm pb-2 font-semibold text-gray-500">
                <span className=" text-blue-600">*</span>Latitude
              </label>
              <input
                type="text"
                className="border-2 border-gray-700 px-3 py-2"
                value={Lat}
                placeholder="Ex: 22.82433"
                onChange={(e) => setLat(e.target.value)}
              />
            </div>
            <div className="flex flex-col flex-1">
              <label className="text-sm pb-2 font-semibold text-gray-500">
                <span className=" text-blue-600">*</span>Longitude
              </label>
              <input
                type="text"
                className="border-2 border-gray-700 px-3 py-2"
                value={Long}
                placeholder="Ex: 28.1349"
                onChange={(e) => setLong(e.target.value)}
              />
            </div>
          </div>
          <div className="flex flex-row justify-between gap-x-10 pb-4">
            <div className="flex flex-col flex-1">
              <label className="text-sm pb-2 font-semibold text-gray-500">
                <span className=" text-blue-600">*</span>Destination Latitude
              </label>
              <input
                type="text"
                className="border-2 border-gray-700 px-3 py-2"
                value={DisLat}
                placeholder="Ex: 22.87322"
                onChange={(e) => setDisLat(e.target.value)}
              />
            </div>
            <div className="flex flex-col flex-1">
              <label className="text-sm pb-2 font-semibold text-gray-500">
                <span className=" text-blue-600">*</span>Destination Longitude
              </label>
              <input
                type="text"
                className="border-2 border-gray-700 px-3 py-2"
                value={DisLong}
                placeholder="Ex: 28.13243"
                onChange={(e) => setDisLong(e.target.value)}
              />
            </div>
          </div>
          <div className="flex flex-row justify-between gap-x-10 pb-4">
            <div className="flex flex-col flex-1">
              <label className="text-sm pb-2 font-semibold text-gray-500">
                <span className=" text-blue-600">*</span>Device Id 1
              </label>
              <input
                type="text"
                className="border-2 border-gray-700 px-3 py-2"
                value={DeviceId1}
                placeholder="Ex: 56dfgh654c356i2ewo76tvb"
                onChange={(e) => setDeviceId1(e.target.value)}
              />
            </div>
            <div className="flex flex-col flex-1">
              <label className="text-sm pb-2 font-semibold text-gray-500">
                <span className=" text-blue-600">*</span>Device Id 2
              </label>
              <input
                type="text"
                className="border-2 border-gray-700 px-3 py-2"
                value={DeviceId2}
                placeholder="Ex: 56dfgh654c356i2ewo76tvb"
                onChange={(e) => setDeviceId2(e.target.value)}
              />
            </div>
          </div>
          <div className="flex flex-row justify-between gap-x-10 pb-4">
            <div className="flex flex-col flex-1">
              <label className="text-sm pb-2 font-semibold text-gray-500">
                <span className=" text-blue-600">*</span>Remarks
              </label>
              <input
                type="text"
                className="border-2 border-gray-700 px-3 py-2"
                value={Remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>
          </div>
          <div className="flex flex-row justify-between">
            <p className="text-xs text-blue-600 pt-2">
              *Fields cannot be made empty
            </p>
            <Button type="primary" onClick={() => callCreatePIS()}>
              Create
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
